export const handleApiError = (error) => {
    if (
        error.response?.status === 401 &&
        error.response?.data?.message === "Session expired"
    ) {
        alert("Your login is active in another browser so you can not relogged in.");
        // Clear storage
        localStorage.clear();
        sessionStorage.clear();

        // Redirect to login
        window.location.href = "/login";
    }

    throw error;
};